import React, { useContext } from "react";

import classNames from "classnames";
import { observer } from "mobx-react";
import PropTypes from "prop-types";
import styled from "styled-components";

import ComponentContext from "../../../contexts/ComponentContext";

const StyledVacancyImage = styled.div`
  flex: ${({ $small }) => ($small ? "0 0 50px" : "0 0 80px;")}
  height: ${({ $small }) => ($small ? "50px" : "80px;")};
  background-color: ${({ backgroundColor }) => backgroundColor || "#fff"};
  background-size: cover;
  background-repeat: no-repeat;
  background-position: center;
  background-image: ${({ imageUrl }) => `url(${imageUrl})`};
  padding: 25px;
  margin-top: auto;
  margin-bottom: auto;
`;

function VacancyImage(props) {
  const { imageUrl, small } = props;

  const { additionalConfig } = useContext(ComponentContext);

  if (!imageUrl) {
    return null;
  }

  return (
    <StyledVacancyImage
      $small={small}
      backgroundColor={additionalConfig?.thumbnail?.backgroundColor}
      className={classNames(
        { "me-2": small, "me-4": !small },
        "d-flex align-items-center"
      )}
      imageUrl={imageUrl}
    />
  );
}

VacancyImage.defaultProps = {
  imageUrl: null,
  small: false,
};

VacancyImage.propTypes = {
  imageUrl: PropTypes.string,
  small: PropTypes.bool,
};

export default observer(VacancyImage);
